import { render, staticRenderFns } from "./PivotConfigGroup.vue?vue&type=template&id=1c947ba2&scoped=true&"
import script from "./PivotConfigGroup.vue?vue&type=script&lang=js&"
export * from "./PivotConfigGroup.vue?vue&type=script&lang=js&"
import style0 from "./PivotConfigGroup.vue?vue&type=style&index=0&id=1c947ba2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c947ba2",
  null
  
)

export default component.exports